import type { FaireProductEntity } from "../../entity_types/product";

export const p_pju45djaj5: FaireProductEntity = {
  token: "p_pju45djaj5",
  type: "product",
  name: "pink cake sticker",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/d52e3ae86f7eceecfa1f8f9a1e224cbf7622689f1fdd2824facf5e62df32a58a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd53a09c9b094f03946a37945d5842bcaf449c971a875673f8d080994b289795.jpeg",
  ],
  priceDollars: 2,
  description:
    'Add this sticker to your water bottle, laptop, journal, envelopes, and more. \n\nDetails:\n- vinyl sticker\n- 3" x 2"\n- Original watercolor artwork by Emily Lex\n\n\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:12.042Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
